import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";

import { withStyles } from "@mui/styles";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import PeopleIcon from "@mui/icons-material/GroupAdd";
import AddCircleIcon from "@mui/icons-material/Add";
import Modal from "@mui/material/Modal";
import IconButton from "@mui/material/IconButton";

import OrganizationRaw from "./OrganizationRaw";
import UserProfileCard from "shared/dist/components/UserProfileCard";

import { useStyles } from "./styles";
import { userActions } from "../../../Services/Redux/actionCreators";
import { GlobalRoutes } from "../../../GlobalRouter/Routes";
import { rejectedStatuses } from "../../../Utils/organizationSetup";
import { resetOrganizationDetailsData } from "../../../Services/Redux/actionCreators/organizationActions";

const UserProfilePopUp = ({ classes, show, handleClose, headerType }) => {
    const { nickname, orgList, orgUuid } = useSelector((state) => ({
        nickname: state.user.nickname,
        orgList: state.organization.organizationsList,
        orgUuid: state.organization.uuid,
    }));
    const dispatch = useDispatch();
    const history = useHistory();

    const handleSignout = () => {
        dispatch(userActions.loginActions.signout);
        history.push(GlobalRoutes.OVERVIEW.path);
    };

    const handleTeamMembers = () => {
        const path = GlobalRoutes.INVITE_MEMBERS.path.replace(":orgUuid", orgUuid);
        history.push(path);
    };

    const handleCreateOrganization = () => {
        dispatch(resetOrganizationDetailsData());
        history.push(GlobalRoutes.ONBOARDING.path);
    };

    const isOrganizationDisplay = (organization) => {
        return organization.uuid && !rejectedStatuses.includes(organization.state.state);
    };

    return (
        <Modal open={show} onClose={handleClose} disableAutoFocus>
            <div
                className={`${classes.UserProfilePopUpContainer} ${headerType === "mobile" ? classes.mobUserProPopup : null}`}
            >
                <UserProfileCard nickName={nickname} />
                <ul className={classes.userProfileMenuList}>
                    <li className={classes.teamListItem} onClick={handleTeamMembers}>
                        <span className={classes.title}>Team</span>
                        <PeopleIcon />
                    </li>
                    <li className={classes.teamListItem}>
                        <span className={classes.title}>Organizations</span>
                        <IconButton onClick={handleCreateOrganization}>
                            <AddCircleIcon />
                        </IconButton>
                    </li>
                    {orgList.map(
                        (organization) =>
                            isOrganizationDisplay(organization) && (
                                <li key={organization.uuid}>
                                    <OrganizationRaw
                                        orgUuid={organization.uuid}
                                        orgImg={organization.assets.heroImage.url}
                                        orgName={organization.name}
                                        orgStatus={organization.state.state}
                                        orgOwner={organization.owner.username}
                                        handleClose={handleClose}
                                    />
                                </li>
                            )
                    )}
                    <li className={classes.signoutLink} onClick={handleSignout}>
                        <ExitToAppIcon />
                        <span>Sign Out</span>
                    </li>
                </ul>
            </div>
        </Modal>
    );
};

export default withStyles(useStyles)(UserProfilePopUp);
